<template>
	<div>
		<div>
			<b-table-simple sticky-header class="table mb-0" :style="{ minHeight: '80vh' }">
				<b-thead>
					<b-tr>
						<b-th v-for="(title, key) in headTable" :key="title.key">
							<div class="d-flex align-items-center justify-content-center cursor-pointer">
								<p class="mb-0 text-center">{{ title.title }}</p>
								<!-- <FeatherIcon
										v-if="orderBy == title.key"
										:icon="order == 'asc' ? 'ArrowUpCircleIcon' : 'ArrowDownCircleIcon'"
										size="18"
									/> -->
							</div>
						</b-th>
					</b-tr>
				</b-thead>
				<b-tbody>
					<b-tr v-if="chickens.length > 0" class="row-table" v-for="(item, index) in chickens" :key="index">
						<!-- <b-td class="text-center">
							<div class="d-flex align-items-center justify-content-center">
								<CombChickenlegsCintillos
									v-if="item.cintillos && item.cintillos.id"
									:postura="{
										chickenleg_wich_leg: item.cintillos.chickenleg_wich_leg,
										chickenleg_qty_cintillos: item.cintillos.qty_cintillos,
										cintillo_color: item.cintillos.hex_1,
										cintillo_description: item.cintillos.description_1,
										second_color_color: item.cintillos.hex_2,
										second_color_description: item.cintillos.description_2,
										total_minus_infertile_eggs: 1,
									}"
									:chickenleg_wich_leg="1"
									is_in_posturas
								/>
								<CombChickenlegsCintillos
									v-if="item.cintillos && item.cintillos.id"
									:postura="{
										chickenleg_wich_leg: item.cintillos.chickenleg_wich_leg,
										chickenleg_qty_cintillos: item.cintillos.qty_cintillos,
										cintillo_color: item.cintillos.hex_1,
										cintillo_description: item.cintillos.description_1,
										second_color_color: item.cintillos.hex_2,
										second_color_description: item.cintillos.description_2,
										total_minus_infertile_eggs: 1,
									}"
									:chickenleg_wich_leg="2"
									is_in_posturas
								/>
							</div>
						</b-td> -->

						<b-td class="text-center">
							{{ item.lote_code }}
						</b-td>

						<b-td class="text-center">
							<vue-number-input
								style="width: 120px"
								:min="1"
								:max="100"
								center
								vertical
								controls
								v-model="item.quantity"
								:disabled="item.l_status == 'FINALIZADO'"
							></vue-number-input>
						</b-td>

						<b-td class="text-center">
							<div>
								<div class="d-flex align-items-center justify-content-center pr-1 pl-1 mt-50">
									<div
										@click="item.type_output_id = item.type_output_id == 4 ? 5 : 4"
										class="container-switch mr-50"
									>
										<div class="barra" :class="[item.type_output_id == 4 ? '' : 'active']"></div>
										<div class="barra-text">
											<div class="w-50 d-flex justify-content-center align-items-center">
												<p
													class="mb-0"
													:class="[item.type_output_id == 4 ? 'text-light' : 'text-primary']"
												>
													Muerto
												</p>
											</div>
											<div class="w-50 d-flex justify-content-center align-items-center">
												<p
													class="mb-0"
													:class="[item.type_output_id == 4 ? 'text-primary' : 'text-light']"
												>
													Depurado
												</p>
											</div>
										</div>
									</div>

									<FeatherIcon
										@click="item.l_status != 'FINALIZADO' && resurrect(item)"
										v-b-tooltip.hover
										:title="item.l_status != 'FINALIZADO' ? 'Restaurar' : 'Restaurar bloqueado'"
										class=""
										icon="PlusSquareIcon"
										size="18"
										:class="[
											item.l_status != 'FINALIZADO'
												? 'cursor-pointer text-danger'
												: 'text-secondary',
										]"
									/>
								</div>
							</div>
						</b-td>

						<b-td class="text-center">
							<v-select
								v-model="item.r_id"
								:options="reasonsArray"
								:clearable="false"
								label="reason"
								:reduce="(option) => option.id"
								placeholder="Elegir razon de muerte"
								style="width: 280px"
								:disabled="item.type_output_id == 5"
							>
								<template v-slot:option="option">
									<div class="d-flex justify-content-between align-items-center">
										<span :style="`margin-left: ${option.parent_id ? '10' : '0'}px`">
											{{ option.reason }}
										</span>
										<span v-if="option.parent_id">Sub-motivo de {{ option.parent_reason }}</span>
									</div>
								</template>
							</v-select>
						</b-td>

						<b-td class="text-center">
							<b-form-textarea
								style="width: 240px"
								v-model="item.observation"
								rows="3"
								max-rows="6"
							></b-form-textarea>
							<!-- placeholder="Agregar observacion" -->
						</b-td>

						<b-td class="text-center">
							<template v-if="item.created_by">
								<p class="mb-0">{{ item.created_by }}</p>
								<span class="font-small-4">{{ item.created_at | myGlobalDayShort }}</span>
							</template>
							<template v-else>
								<p class="mb-0">Sin usuario</p>
							</template>
						</b-td>

						<b-td class="text-center">
							<div class="grid-images-details-ca">
								<div class="image-item" v-for="(image, key) in item.evids">
									<img class="" :src="image.image" alt="" />
									<FeatherIcon
										@click="removeImage(image)"
										icon="XCircleIcon"
										size="24"
										class="icon-delete cursor-pointer"
									/>
								</div>
								<!--  -->
								<div class="image-not-found">
									<p class="mb-0">Click para subir imagen</p>
									<input
										@input="addImageArrayChick(index)"
										class="input"
										type="file"
										ref="fileInput"
									/>
								</div>
							</div>
						</b-td>
					</b-tr>
					<b-tr v-if="chickens.length == 0">
						<b-td colspan="7" class="text-center">
							<p class="mb-0">Sin cintillos encontrados</p>
						</b-td>
					</b-tr>
				</b-tbody>
			</b-table-simple>
		</div>
		<div class="mt-2 d-flex justify-content-end" v-if="chickens.length > 0">
			<button class="btn btn-primary" @click="saveChanges">Guardar cambios</button>
		</div>
	</div>
</template>

<script>
import deadsService from "@/services/deads.service"
import reasonsService from "@/services/reasons.service"
import { setEvidencesBase64 } from "@/helpers/functions"
import CombChickenlegsCintillos from "../../encaste/lotes/components/CombChickenlegsCintillos.vue"
import heic2any from "heic2any"

export default {
	components: {
		CombChickenlegsCintillos,
	},
	props: {
		posturaId: Number,
	},
	data() {
		return {
			headTable: [
				{ key: "lote", title: "Lote" },
				{ key: "quantity", title: "Cantidad" },
				{ key: "status", title: "Estado" },
				{ key: "reason", title: "Razon" },
				{ key: "observation", title: "Observacion" },
				{ key: "created_by", title: "Creado por" },
				{ key: "evidencias", title: "Evidencias" },
			],
			chickens: [],
			reasonsArray: [],
		}
	},

	async mounted() {
		await this.getReasons()
		await this.init()
	},
	methods: {
		async init() {
			this.isPreloading()
			const {
				data: { message, deads },
			} = await deadsService.getDetailDeadByPostura({
				type: 1,
				posture_id: this.posturaId,
			})
			this.chickens = deads.map((it) => {
				let cintillos = {
					...it.cintillos,
					chickenleg_wich_leg:
						it.cintillos &&
						(it.cintillos.wich_leg == "IZQUIERDA" ? 1 : it.cintillos.wich_leg == "DERECHA" ? 2 : 3),
				}
				return {
					...it,
					evids: it.evids.filter((e) => e.id !== null),
					evids_delete: [],
					customFormData: [],
					cintillos: it.cintillos ? cintillos : null,
				}
			})
			this.isPreloading(false)
		},
		async getReasons() {
			const resp = await reasonsService.getByModule(1, 3)
			this.reasonsArray = resp
		},
		addImageArrayChick(key) {
			this.$refs.fileInput[key].click()
			let input = this.$refs.fileInput[key]
			let file = input.files
			const typeOfFile = file[0] && file[0].name.split(".")[file[0].name.split(".").length - 1]
			if (typeOfFile == "png" || typeOfFile == "jpg" || typeOfFile == "jpeg") {
				// this.setImage(file, "image");
				this.chickens = this.chickens.map((it, index) => {
					if (index == key) {
						return {
							...it,
							evids: [
								...it.evids,
								{
									id: null,
									image: URL.createObjectURL(file[0]),
									thumb: URL.createObjectURL(file[0]),
									file: file[0],
								},
							],
						}
					}
					return it
				})
			} else if (typeOfFile == "heif" || typeOfFile == "heic") {
				this.isPreloading()
				this.showToast(
					"warning",
					"top-right",
					"Cargando imagen, espere un momento",
					"CheckIcon",
					"El formato HEIF o HEIC no es soportado, por ello lo puede tardar un momento."
				)
				heic2any({ blob: file[0], toType: "image/jpg", quality: 1 }).then((newImage) => {
					const url = URL.createObjectURL(newImage)
					let newFile = new File([newImage], "heic" + ".jpg", {
						type: "image/jpeg",
						lastModified: new Date().getTime(),
					})
					this.chickens = this.chickens.map((it, index) => {
						if (index == key) {
							return {
								...it,
								evids: [
									...it.evids,
									{
										id: null,
										image: url,
										thumb: url,
										file: newFile,
									},
								],
							}
						}
						return it
					})

					this.isPreloading(false)
				})
				this.$refs.fileInput.value = null
			}
		},
		async saveChanges() {
			this.isPreloading()

			this.chickens = await setEvidencesBase64(
				this.chickens.map((it) => {
					return {
						...it,
						evidences: it.evids.filter((e) => e.id === null).map((it) => it.file),
					}
				})
			)

			const deads = this.chickens.map((it) => {
				return {
					type: 1,
					id: null,
					reason_id: it.type_output_id == 4 ? it.r_id : null,
					// circunstances: null,
					// breeder_id: null,
					lote_id: it.lote_id,
					elo_id: it.elo_id,
					type_output_id: it.type_output_id,
					error: null,
					observation: it.observation,
					// status_id: it.status_id,
					quantity: it.quantity,
					evids_to_add: it.evids.filter((image) => !image.id),
					evids_to_delete: it.evids_delete.map((it) => it.id),
					customFormData: it.customFormData,
				}
			})
			const {
				data: { message },
			} = await deadsService.updateDeads({
				deads,
				id: this.posturaId,
				type: 1,
			})
			this.isPreloading(false)
			this.showToast("success", "top-right", "Muertos", "AlertCircleIcon", message)
			await this.init()
		},
		removeImage(item) {
			this.chickens = this.chickens.map((it) => {
				return {
					...it,
					evids: it.evids.filter((e) => e.id != item.id),
					evids_delete: [...it.evids_delete, ...it.evids.filter((e) => e.id == item.id)],
				}
			})
			this.showToast("success", "top-right", "Muertos", "AlertCircleIcon", "Imagen removida correctamente.")
		},
		async resurrect(item) {
			const { isConfirmed } = await this.showConfirmSwal()
			if (!isConfirmed) return
			this.isPreloading()
			const {
				data: { message },
			} = await deadsService.toReviveCACP({
				id: item.elo_id,
				type: 1,
				// elo_id: item.elo_id,
				lote_id: item.lote_id,
			})
			this.chickens = this.chickens.filter((it) => it.ck_id != item.ck_id)
			if (this.chickens.length == 0) {
				this.$emit("refreshTableZero")
			}
			this.isPreloading(false)
			this.showToast("success", "top-right", "Muertos", "AlertCircleIcon", message)
		},
	},
}
</script>

<style lang="scss" scoped>
.grid-images-details-ca {
	display: flex;
	// background: var(--primary);
	justify-content: center;
	overflow-x: auto;
	// padding-left: 4rem;
	width: 500px;
	// width: 400px;
	// min-width: 400px;
	// flex-wrap: wrap;
	// overflow-x: ;
	// box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
	padding: 0.5rem;
	.image-item {
		position: relative;
		box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
		margin: 0 5px;
		margin-bottom: 0.8rem;
		.icon-delete {
			position: absolute;
			top: -4px;
			right: -4px;
			color: red;
			background: #fff;
			border-radius: 50%;
		}
	}
	img {
		width: 100px !important;
		height: 100px !important;
		object-fit: cover;
		// margin: 0 5px;
		border: 2px solid var(--primary);
		border-radius: 4px;
	}
	.image-not-found {
		box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
		width: 100px !important;
		height: 100px !important;
		margin: 0 5px;
		border: 2px dashed gray;
		border-radius: 4px;
		padding: 1.5rem;
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
		position: relative;
		p {
			font-size: 13px;
			line-height: 1.2;
		}
		.input {
			position: absolute;
			top: 0;
			left: 0;
			bottom: 0;
			right: 0;
			opacity: 0;
			cursor: pointer;
		}
	}
}
.grid-images-details-ca::-webkit-scrollbar {
	width: 4px !important;
	background: #d5d1fb !important;
	height: 4px;
}

.grid-images-details-ca::-webkit-scrollbar-thumb {
	background: var(--primary) !important;
	border-radius: 6px !important;
}

.container-switch {
	background: #e4e3e3;
	width: 140px;
	height: 40px;
	border-radius: 25px;
	position: relative;
	cursor: pointer;
	// box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
	box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
	.barra {
		position: absolute;
		top: 3px;
		left: 3px !important;
		width: 67px;
		height: 34px;
		background: var(--primary);
		border-radius: 34px;
		transition: all 0.3s ease;
		box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
	}
	.barra-text {
		display: flex;
		justify-content: space-between;
		align-items: center;
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		// padding: 0 .5rem;
		p {
			font-size: 10px;
			font-weight: bolder;
		}
	}
	.active {
		left: calc(67px + 3px) !important;
	}
}
</style>
